export const EnterpriseGroup = (builder) => ({
  EnterpriseGroup: builder.mutation({
    query: ({ user_id = "", search = "", pageNumber = 1, limit = "", user_type, sortBy, sortOrder }) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: `/list_of_enterprise_user_details/${user_id}`,
        method: "GET",
        params: { pageNumber, search, limit, user_type, sortBy, sortOrder },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
    },
  }),
});
